<!-- 简单复制、阉割了单选框，可能存在BUG（待验证） -->
<!-- 不支持列表中使用 -->
<template>
    <div>
        <el-select
            style="width: 100%"
            v-model="model_value"
            :placeholder="model_name"
            :clearable="is_clearable"
            filterable
            @change="onChange"
            multiple
            :disabled="is_disable"
            v-show="is_show"
            ref="commonSelect"
        >
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    name: 'commonDropDownMul',
    props: {
        model_key: {
            // 请求后台的参数key
            type: String
        },
        model_name: {
            // 下拉框预显示名称
            type: String
        },
        model_value_default: {
            // 默认值，编辑页面需要用
            default: function () {
                return [];
            }
        },
        request_uri: {
            // 下拉框请求后台的地址映射
            type: String
        },
        request_params: {
            // 下拉框请求后台的参数
            type: Object,
            default: function () {
                return {};
            }
        },
        is_clearable: {
            type: Boolean,
            default: true
        },
        is_disable: {
            // 是否禁用
            type: Boolean,
            default: false
        },
        is_show: {
            // 是否显示
            type: Boolean,
            default: true
        },
        display_name: {
            type: String,
            default: 'name'
        },
        select_value: {
            type: String,
            default: 'rid'
        }
    },
    data() {
        return {
            options: [],
            model_value: []
        };
    },
    mounted() {
        this.initData();
    },
    watch: {
        // 列表上使用该组件，请遵循动态key+formData来实现数据映射
        model_key() {
            this.setDefaultValue();
        },
        model_value_default() {
            this.setDefaultValue();
        }
    },
    methods: {
        reset() {
            this.model_value = [];
        },
        setDefaultValue() {
            this.model_value = this.model_value_default;
        },
        // 初始化数据
        initData() {
            this.$api[this.request_uri](this.request_params)
                .then((res) => {
                    this.options = [];
                    let data = res.data;
                    data.forEach((item) => {
                        this.options.push({
                            value: item[this.select_value],
                            label: item[this.display_name]
                        });
                    });
                    this.setDefaultValue();
                })
                .catch((error) => {});
        },
        onChange(value) {
            this.$emit('onDropChange', this.model_key, this.model_value);
        }
    }
};
</script>

<style>
</style>